import React from 'react';
import type { ArrowDirection } from './ArrowButton';

function findInvizibleNearestChilds(container: HTMLElement) {
    const cr = container.parentElement?.getBoundingClientRect();

    const childs = container.childNodes as unknown as readonly HTMLElement[];

    let left: HTMLElement | undefined;
    let right: HTMLElement | undefined;

    if (! cr) return { left, right };

    childs.forEach(child => {
        const r = child.getBoundingClientRect();

        if (r.x < cr.x) left = child;
        if (r.x + r.width > cr.x + cr.width && ! right) right = child;
    });

    return { left, right };
}

export function useArrowButton() {
    const [ isLeftEdge, setIsLeftEdge ] = React.useState(true);
    const [ isRightEdge, setIsRightEdge ] = React.useState(false);
    const containerRef = React.useRef<HTMLDivElement>(null);

    const onArrowClick = React.useCallback((arrowDirection: ArrowDirection) => {
        const container = containerRef.current;

        if (! container) return;

        const nearest = findInvizibleNearestChilds(container);

        const item = arrowDirection === 'left' ? nearest.left : nearest.right;

        item?.scrollIntoView({
            inline: arrowDirection === 'left' ? 'end' : 'start',
            behavior: 'smooth',
            block: 'nearest'
        });
    }, [ ]);

    const onContainerScroll = React.useCallback((event: React.UIEvent<HTMLDivElement> & { target?: HTMLDivElement }) => {
        const t = event.target;

        if (! t) return;

        setIsLeftEdge(t.scrollLeft === 0);
        // +1 потому скролл не доезжат до конца идеально, не хватало 0.175 что ли.
        setIsRightEdge((t.offsetWidth + t.scrollLeft) + 1 >= t.scrollWidth);
    }, []);

    const [ isScrollNeeded, setIsScrollNeeded ] = React.useState(false);

    React.useEffect(() => {
        const container = containerRef.current;

        if (! container) return;
        const nearest = findInvizibleNearestChilds(container);

        setIsScrollNeeded(Boolean(nearest.left || nearest.right));
    }, []);

    return {
        onArrowClick,
        onContainerScroll,
        isScrollNeeded,
        isLeftEdge,
        isRightEdge,
        containerRef
    };
}
